export default "/_next/static/sounds/trim-page-turn-3-f9bb01f4cb2856c4ea5a5555196beb35.mp3";